/**
 * Permissões do módulo de chaves de luta.
 *
 * Até 09/08/2026 o módulo inteiro era `<ProtectedRoute>` puro: qualquer usuário
 * autenticado gerava chaves, regerava, aplicava programação e registrava
 * resultado. Isso também impedia fechar a fronteira do 1834 — sem permissão
 * própria para escrever chave, não havia o que exigir na regra do banco (ver
 * `docs/CLAIMS-PERMISSAO-NO-TOKEN.md`).
 *
 * Dois níveis, pelo mesmo motivo do par 1834/1835: consultar chaveamento, pódio
 * e telão é o que a maior parte da organização faz, e exigir a permissão de
 * escrita para isso tiraria a tela de quem só acompanha.
 *
 * Vizinhança: 1830-1833 pesagem, 1834/1835 rebalanceamento ao vivo.
 */

/** Gerar e regerar chaves, aplicar programação, registrar resultado na súmula. */
export const CHAVES_OPERAR = 1836;

/** Abrir o módulo em leitura: lista, chaveamento, pódio, listas de quadra, telões. */
export const CHAVES_CONSULTAR = 1837;

/**
 * Quem entra nas telas de leitura: qualquer um dos dois.
 *
 * `ProtectedRoute` trata lista como "qualquer uma delas". Quem opera obviamente
 * consulta — exigir as duas seria armadilha de cadastro.
 */
export const CHAVES_ACESSO = [CHAVES_OPERAR, CHAVES_CONSULTAR];
